import { useTaskLocation } from '../utils/hooks';
import { getStateSealImage } from '../../../utils/seals';
import { USStateAbbrev } from '../../../constants';
import { SectionHeading } from '../../../components';

export const LocationHeader = () => {
  const taskLocation = useTaskLocation();

  if (taskLocation) {
    return (
      <div className="sticky top-0 z-30 flex h-20 items-center gap-x-4 border-b bg-white px-6">
        <img
          src={getStateSealImage(taskLocation.code as USStateAbbrev)}
          className="size-12"
          alt={`${taskLocation.name} state seal`}
        />
        <SectionHeading className="p-0" borderless text={taskLocation.name} />
      </div>
    );
  }

  return null;
};
